import translate, { Lang, t } from '../util/translate';

export function customValidation(form : HTMLFormElement) {
    passwordValidation(form.password, form.password_confirm);
    emailValidation(form.email, form.email_confirm);
    // postalNumberValidation(form.zipCode);
}

export function signUpValidation(form : HTMLFormElement) {
    emailValidation(form.email, form.email_confirm);
}

/**
 * パスワードバリデーション
 */
export function passwordValidation(password : HTMLInputElement, passwordConfirm : HTMLInputElement) {
    // 言語取得
    const lang = (localStorage.getItem('lang') ?? 'ja') as keyof Lang;
    // 形式チェック
    let pattern = /^[0-9a-zA-Z]{8,16}$/;
    if (!password.value.match(pattern)) {
        password.setCustomValidity(t.errPassword1[lang]);
        const pass = <Element> password.nextElementSibling;
        pass.innerHTML = t.errPassword1[lang];
    }

    if (!passwordConfirm.value.match(pattern)) {
        passwordConfirm.setCustomValidity(t.errPassword2[lang]);
        const passconf = <Element> passwordConfirm.nextElementSibling;
        passconf.innerHTML = t.errPassword2[lang];
    }

    // 同値チェック
    if (password.value.match(pattern) || passwordConfirm.value.match(pattern)) {
        if (password.value !== passwordConfirm.value) {
            password.setCustomValidity(t.errPassword3[lang]);
            passwordConfirm.setCustomValidity(t.errPassword3[lang]);
            const pass = <Element> password.nextElementSibling;
            pass.innerHTML = t.errPassword4[lang];
            const passconf = <Element> passwordConfirm.nextElementSibling;
            passconf.innerHTML = t.errPassword5[lang];
        } else {
            password.setCustomValidity('');
            passwordConfirm.setCustomValidity('');
        }
    }
}

/**
 * メールバリデーション
 */
 export function emailValidation(email : HTMLInputElement, emailConfirm : HTMLInputElement) {
    // 言語取得
    const lang = (localStorage.getItem('lang') ?? 'ja') as keyof Lang;
    // TODO 形式チェックは一旦フォームに任せている。もう少し厳密にする必要があるなら対応
    // 同値チェック
    if (email.value !== emailConfirm.value) {
        email.setCustomValidity(t.errEmail1[lang]);
        emailConfirm.setCustomValidity(t.errEmail2[lang]);
        const mail = <Element> email.nextElementSibling;
        mail.innerHTML = t.errEmail1[lang];
        const mailconf = <Element> emailConfirm.nextElementSibling;
        mailconf.innerHTML = t.errEmail2[lang];
    } else {
        const mail = <Element> email.nextElementSibling;
        mail.innerHTML = t.errEmail3[lang];
        const mailconf = <Element> emailConfirm.nextElementSibling;
        mailconf.innerHTML = t.errEmail3[lang];
        email.setCustomValidity('');
        emailConfirm.setCustomValidity('');
    }
}

/**
 * 郵便番号バリデーション
 */
function postalNumberValidation(zipCode : HTMLInputElement) {
    // 言語取得
    const lang = (localStorage.getItem('lang') ?? 'ja') as keyof Lang;
    // 形式チェック
    let pattern = /^[0-9]{3}-*[0-9]{4}$/;
    if (!zipCode.value.match(pattern)) {
        zipCode.setCustomValidity(t.errPost1[lang]);
        const postnum = <Element> zipCode.nextElementSibling;
        postnum.innerHTML = t.errPost1[lang];
    } else {
        zipCode.setCustomValidity('');
    }
}


/**
 * パスワードバリデーション
 */
 export function passwordValidation_single(password : HTMLInputElement) {
    // 形式チェック
    let pattern = /^[0-9a-zA-Z]{8,16}$/;
    if (!password.value.match(pattern)) {
        password.setCustomValidity('パスワードは半角英数字8文字以上16字以下で入力してください。');
        const pass = <Element> password.nextElementSibling;
        pass.innerHTML = 'パスワードは半角英数字8文字以上16字以下で入力してください。';
    }else {
        password.setCustomValidity('');
    }
}

/**
 * メールバリデーション
 */
 export function emailValidation_single(email : HTMLInputElement) {
    const lang = (localStorage.getItem('lang') ?? 'ja') as keyof Lang;
    let pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
    if (!email.value.match(pattern)) {
        email.setCustomValidity(t.errEmail1[lang]);
        const mail = <Element> email.nextElementSibling;
        mail.innerHTML = t.errEmail1[lang];
    } else {
        email.setCustomValidity('');
    }

}
